import React from 'react';

/**
 *
 */
export default class DropdownMenu extends React.Component {
  render () {
    const listItems = this.props.data.map((item, index) => {
      if (item.to === 'divider') {
        return <li className="divider" key={index}></li>
      }
      return <li key={index}><a href={item.to}>{item.text}</a></li>
    });
    return <ul className="dropdown-menu">{listItems}</ul>
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/bootstrap/DropdownMenu.js